import React, { useState, useEffect } from 'react'
import "./Pastbooking.css"
import { Link } from 'react-router-dom'
import { Pastsession } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'

const Pastbooking = () => {
  const [pastseesiondata, setPastSessionData] = useState([]);
  const [Loading, setLoading] = useState(false);

  const handlePasesession = async () => {
    let token = localStorage.getItem("token");
    try {
      setLoading(true)
      const response = await Pastsession(token);
      setPastSessionData(response.data?.data || response.data || []);
    } catch (error) {
      console.error("Error during Dashboard request:", error);

    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    handlePasesession();
  }, []);


  return (
    <>
      {Loading && <Loader />}
      <div className="Passbooking-top">

        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4'>
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <img
                className="img-fluid left-arrow-img"
                src="./Images/left-arrow.svg"
                alt="arrow"
              />
            </Link>

            <span className='title d-flex align-items-center justify-content-center mt-3'>Past Bookings</span>
          </div>

          <div className='pastbooking-info p-3'>
            {/* Past Bookings */}
            <div className="booking-today-info mt-2 d-flex flex-column gap-2">
              {pastseesiondata && pastseesiondata.length > 0 ? (
                pastseesiondata?.map((item, id) => (
                  <>
                    <Link to={`/appointmentdetail/${encodeURIComponent(item?._id)}`}
                      key={id} className="pastbooking-inner" style={{ textDecoration: 'none' }}>
                      <div className="d-flex align-items-center" style={{ padding: "12px" }}>
                        <span className="upcoming-schedule d-flex gap-1">
                          {
                            item?.date
                              ? <span>{moment(item?.date).format("DD MMM")}</span>
                              : ""
                          }
                          {
                            item?.fromTime
                              ? <span>{`${moment(item?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(item?.toTime, "HH:mm:ss").format("hh:mm A")}`}</span>
                              : ""
                          }
                        </span>

                      </div>
                      <div className="" style={{ borderBottom: "1.5px dashed #BEBEBE" }}></div>
                      <div className='p-3'>
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="d-flex flex-column flex-grow-1 gap-1">
                            <span className="user-details">{item?.member?.first_name} {item?.member?.last_name}</span>
                            {/* <div className="d-flex gap-1 align-items-center">
                          <span className="user-common">26 years</span>
                          <span className="vertical-border"></span>
                          <span className="user-common">Male</span>
                        </div> */}
                            <span className="user-address">{item?.member?.address}</span>
                          </div>
                          {item?.status === "assigned" ? (
                            <div className="slot-progressbar-conatiner p-1">
                              <span className="slot-progressbar">In Progress</span>
                            </div>
                          ) : item?.status === "completed" ? (
                            <div className="slot-Completed-conatiner p-1">
                              <span className="slot-complete-progressbar">Completed</span>
                            </div>
                          ) : (
                            <div className="slot-Onway-conatiner p-1">
                              <span className="slot-Onway-progressbar">Ongoing</span>
                            </div>
                          )}
                        </div>

                        <div className="schedule-details-container d-flex flex-column p-3 mt-3">
                          <span className="booking-id">Booking ID - {item?.booking?.booking_number}</span>
                          <div className="Session-details d-flex flex-sm-row gap-5 gap-md-5 justify-content-md-between w-100 mt-2">
                            <div>
                              <span className="text">Session Time</span>
                              <div className="d-flex justify-content-between">
                                <span className="date">
                                  {item?.fromTime
                                    ? `${moment(item?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(item?.toTime, "HH:mm:ss").format("hh:mm A")}`
                                    : ""}
                                </span>
                              </div>
                            </div>
                            <div>
                              <span className="text">Service</span>
                              <div className="d-flex justify-content-between">
                                <span className="date text-capitalize">{item?.interest?.name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </Link>
                  </>


                ))
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <span className="not-available">Past booking data not available</span>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </>


  )
}

export default Pastbooking